const applyCloudinaryLimits = (url: string) => {
  if (!url.includes('/upload/') || url.includes('keep_original')) return url;

  const [base, rest] = url.split('/upload/');
  const [firstSegment, ...remainingPath] = rest.split('/');

  const isTransform = /^([a-z]{1,2}_[^/]+,?)+$/.test(firstSegment);
  const transformationParts = isTransform ? firstSegment.split(',').filter(Boolean) : [];
  const otherSegments = isTransform ? remainingPath : [firstSegment, ...remainingPath];

  const hasFormat = transformationParts.some((part) => part.startsWith('f_'));

  if (!hasFormat) {
    transformationParts.push('f_auto');
  }

  return `${base}/upload/${transformationParts.join(',')}/${otherSegments.join('/')}`;
};

interface CommonImageProps {
  src: string;
  alt?: string;
  className?: string;
}

export const CommonImage = ({ src, alt, ...rest }: CommonImageProps) => {
  const finalSrc = applyCloudinaryLimits(src);

  return <img {...rest} alt={alt} src={finalSrc} />;
};
